import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pagina-no-encontrada404',
  templateUrl: './pagina-no-encontrada404.component.html',
  styleUrls: ['./pagina-no-encontrada404.component.css']
})
export class PaginaNoEncontrada404Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
